export const CHANGE_UNIT = 'CHANGE_UNIT';
export const SET_MOTOR_TYPES = 'SET_MOTOR_TYPES';

export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const RESET_AUTH = 'RESET_AUTH';
export const LOAD_STORED_AUTH = 'LOAD_STORED_AUTH';
